// src/app/pages/contact/contact.component.ts

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EmailJsService } from '../../services/emailjs.service';
import { SeoService } from '../../services/seo.service';

interface Contact {
  name: string;
  email: string;
  message: string;
}

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {
  contact: Contact = { name: '', email: '', message: '' };
  submitted = false;
  isSubmitting = false;
  errorMessage = '';

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly contactPageId =
    `${this.baseUrl}/contact#contact`;

  constructor(
    private emailJsService: EmailJsService,
    private seo: SeoService
  ) {}

  ngOnInit(): void {
    this.seo.update(
      'Contact',
      'Get in touch with Lydia Christensen for U.S. Senate. Reach out for press inquiries, volunteer coordination, or general questions.',
      'contact'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",

      "@graph": [
        {
          "@type": "ContactPage",

          "@id": this.contactPageId,

          "url": `${this.baseUrl}/contact`,

          "name": "Contact Lydia Christensen",

          "description":
            "Get in touch with Lydia Christensen for U.S. Senate. Reach out for press inquiries, volunteer coordination, or general questions.",

          "isPartOf": {
            "@id": this.seo.websiteId
          },

          "about": {
            "@id": this.seo.lydiaId
          },

          "publisher": {
            "@id": this.seo.campaignId
          },

          "inLanguage": "en-US"
        }
      ]
    });
  }

  async onSubmit(): Promise<void> {
    this.isSubmitting = true;
    this.errorMessage = '';
    this.submitted = false;

    try {
      const response = await this.emailJsService.sendEmail(
        this.contact,
        'Contact'
      );

      this.submitted = true;

      console.log(
        'Email sent successfully:',
        response
      );

    } catch (error: any) {

      this.errorMessage =
        'Failed to send message. Please try again later.';

      console.error(
        'Email sending failed:',
        error.text
      );

    } finally {

      this.isSubmitting = false;
    }
  }

  resetForm(): void {
    this.submitted = false;
    this.contact = {
      name: '',
      email: '',
      message: ''
    };
    this.errorMessage = '';
  }
}